import { BigNumber, FixedNumber } from '@ethersproject/bignumber'

export const FIXED_ZERO = FixedNumber.from(0)
export const FIXED_ONE = FixedNumber.from(1)
export const FIXED_TWO = FixedNumber.from(2)

export const BIG_TEN = BigNumber.from(10)
export const FIXED_TEN_IN_POWER_18 = FixedNumber.from(BIG_TEN.pow(18))

export const masterChefAddresses = {
  97: '0xB4A466911556e39210a6bB2FaECBB59E4eB7E43d',
  56: '0x7c9320bb9Baf12C08D04dC2085E4AaBcC26084D5',
  2000: '0x065AAE6127D2369C85fE3086b6707Ac5dBe8210a',
}

export const nonBSCVaultAddresses = {}
